{
  "about.blocks": "मॉडरेट सर्वर",
  "about.contact": "कांटेक्ट:",
  "about.default_locale": "Default",
  "about.disclaimer": "मास्टोडन एक ओपन सोर्स सॉफ्टवेयर है, और मास्टोडन gGmbH का ट्रेडमार्क है।",
  "about.domain_blocks.no_reason_available": "कारण उपलब्ध नहीं है!",
  "about.domain_blocks.preamble": "मास्टोडन आम तौर पर आपको कंटेंट को देखने और फेडिवेर्से में किसी अन्य सर्वर से उपयोगकर्ताओं के साथ बातचीत करने की अनुमति देता है। ये अपवाद हैं जो इस विशेष सर्वर पर बनाए गए हैं।",
  "about.domain_blocks.silenced.explanation": "आप आमतौर पर इस सर्वर से प्रोफ़ाइल और कंटेंट नहीं देख पाएंगे, जब तक कि आप इसे स्पष्ट रूप से नहीं देखते या इसका अनुसरण करके इसका चयन नहीं करते।",
  "about.domain_blocks.silenced.title": "सीमित",
  "about.domain_blocks.suspended.explanation": "इस सर्वर से कोई डेटा संसाधित, संग्रहीत या आदान-प्रदान नहीं किया जाएगा, जिससे इस सर्वर से उपयोगकर्ताओं के साथ कोई भी बातचीत या संचार असंभव हो जाएगा",
  "about.domain_blocks.suspended.title": "सस्पेंड किआ गया है!",
  "about.language_label": "भाषा",
  "about.not_available": "यह जानकारी इस सर्वर पर उपलब्ध नहीं कराई गई है।",
  "about.powered_by": "{mastodon} द्वारा संचालित डेसेंट्रलीसेड सोशल मीडिया प्लैटफ़ॉर्म!",
  "about.rules": "सर्वर के नियम",
  "account.account_note_header": "व्यक्तिगत नोंध",
  "account.add_or_remove_from_list": "सूची में जोड़ें या हटाए",
  "account.badges.bot": "बॉट",
  "account.badges.group": "समूह",
  "account.block": "@{name} को ब्लॉक करें",
  "account.block_domain": "{domain} के सारी चीज़े छुपाएं",
  "account.block_short": "ब्लॉक किया गया",
  "account.blocked": "ब्लॉक",
  "account.cancel_follow_request": "फॉलो रिक्वेस्ट वापस लें",
  "account.copy": "प्रोफाइल पर लिंक कॉपी करें",
  "account.direct": "निजि तरीके से उल्लेख करे @{name}",
  "account.disable_notifications": "@{name} पोस्ट के लिए मुझे सूचित मत करो",
  "account.edit_profile": "प्रोफ़ाइल संपादित करें",
  "account.edit_profile_short": "संपादित करें",
  "account.enable_notifications": "जब @{name} पोस्ट मौजूद हो सूचित करें",
  "account.endorse": "प्रोफ़ाइल पर दिखाए",
  "account.familiar_followers_many": "{name1}{name2} और {othersCount, plural, one {एक और जिन्हे आप जानते है} other {# और जिन्हे आप जानते है}}",
  "account.familiar_followers_one": "{name1} ने अनुसरण किया है",
  "account.familiar_followers_two": "{name1} और {name2} ने अनुसरण किया है",
  "account.featured": "प्रचलित",
  "account.featured.accounts": "प्रोफ़ाइल",
  "account.follow": "फॉलो करें",
  "account.follow_back": "फॉलो करें",
  "account.follow_back_short": "वापस अनुसरण करें",
  "account.follow_request": "अनुसरण करने की बिनती करें",
  "account.follow_request_cancel": "अनुरोध रद्द करें",
  "account.follow_request_cancel_short": "रद्द करें",
  "account.follow_request_short": "अनुरोध करें",
  "account.followers": "फॉलोवर",
  "account.followers.empty": "कोई भी इस यूज़र् को फ़ॉलो नहीं करता है",
  "account.following": "फॉलोइंग",
  "account.follows.empty": "यह यूज़र् अभी तक किसी को फॉलो नहीं करता है।",
  "account.go_to_profile": "प्रोफाइल में जाएँ",
  "account.hide_reblogs": "@{name} के बूस्ट छुपाएं",
  "account.in_memoriam": "याद में",
  "account.joined_short": "पुरा हुआ",
  "account.languages": "सब्स्क्राइब्ड भाषाओं को बदलें",
  "account.link_verified_on": "इस लिंक का स्वामित्व {date} को चेक किया गया था",
  "account.locked_info": "यह खाता गोपनीयता स्थिति लॉक करने के लिए सेट है। मालिक मैन्युअल रूप से समीक्षा करता है कि कौन उनको फॉलो कर सकता है।",
  "account.media": "मीडिया",
  "account.mention": "उल्लेख @{name}",
  "account.moved_to": "{name} ने संकेत दिया है कि उनका नया अकाउंट अब है:",
  "account.mute": "म्यूट @{name}",
  "account.mute_notifications_short": "सूचनाओ को शांत करे",
  "account.mute_short": "शांत करे",
  "account.muted": "म्यूट है",
  "account.no_bio": "कोई विवरण नहि दिया गया हे",
  "account.open_original_page": "ओरिजिनल पोस्ट खोलें",
  "account.posts": "टूट्स",
  "account.report": "रिपोर्ट @{name}",
  "account.requested_follow": "{name} ने आपको फॉलो करने के लिए अनुरोध किया है",
  "account.share": "@{name} की प्रोफाइल शेयर करे",
  "account.show_reblogs": "@{name} के बूस्ट दिखाए",
  "account.unblock": "@{name} को अनब्लॉक करें",
  "account.unblock_domain": "{domain} दिखाए",
  "account.unblock_short": "अनब्लॉक",
  "account.unendorse": "प्रोफ़ाइल पर न दिखाए",
  "account.unfollow": "अनफॉलो करें",
  "account.unmute": "अनम्यूट @{name}",
  "account.unmute_notifications_short": "सूचनाओको मूक करे",
  "account.unmute_short": "अनम्यूट",
  "account_note.placeholder": "नोट्स जोड़ने के लिए क्लिक करें",
  "admin.dashboard.daily_retention": "साईन-अप के बाद उपयोगकर्ता के रिटेंशन दर",
  "admin.dashboard.monthly_retention": "साईन-अप के बाद उपयोगकर्ता के महीने तक रिटेंशन दर",
  "admin.dashboard.retention.average": "औसत",
  "admin.dashboard.retention.cohort": "साईन-अप महिना",
  "admin.dashboard.retention.cohort_size": "नये उपयोगकर्ता",
  "admin.impact_report.instance_accounts": "ये अकाउंट प्रोफाइल मिटा देगा",
  "admin.impact_report.instance_followers": "हमारे यूजर्स इन फॉलोअर्स को खो देंगे",
  "admin.impact_report.instance_follows": "उनके उपयोगकर्ता इतने फ़ॉलोअर खो देंगे",
  "admin.impact_report.title": "प्रभावकां सारांश",
  "alert.rate_limited.message": "कृप्या {retry_time, time, medium} के बाद दुबारा कोशिश करें",
  "alert.rate_limited.title": "सीमित दर",
  "alert.unexpected.message": "एक अप्रत्याशित त्रुटि हुई है!",
  "alert.unexpected.title": "उफ़!",
  "announcement.announcement": "घोषणा",
  "attachments_list.unprocessed": "(असंसाधित)",
  "audio.hide": "हाईड ऑडियो",
  "block_modal.remote_users_caveat": "हम {domain} को आपके निर्णय का सम्मान करने को कहेंगे।हालाकि इसकी आपूर्ति कि प्रत्याभूति नहीं हे। क्योंकि कुछ सर्वर ब्लॉक को अलग तरह से निभा सकते हे। अभी भी सार्वजानिक पोस्ट लोग- इन बगैर के उपयोगकर्ताओं को दिख सकती हैं।",
  "block_modal.show_less": "कम दिखाएं",
  "block_modal.show_more": "और दिखाएँ",
  "block_modal.they_will_know": "वे नहीं देख सकते कि उन्हें ब्लॉक किया गया है",
  "block_modal.title": "यूजर को ब्लॉक करें?",
  "boost_modal.combo": "अगली बार स्किप करने के लिए आप {combo} दबा सकते है",
  "bundle_column_error.copy_stacktrace": "कॉपी एरर रिपोर्ट",
  "bundle_column_error.error.body": "अनुरोधित पेज प्रस्तुत नहीं किया जा सका। यह हमारे कोड में बग या ब्राउज़र संगतता समस्या के कारण हो सकता है।",
  "bundle_column_error.error.title": "अरे, नहीं!",
  "bundle_column_error.network.body": "इस पृष्ठ को लोड करने का प्रयास करते समय एक एरर हुआ है । यह आपके इंटरनेट कनेक्शन या इस सर्वर के साथ एक अस्थायी समस्या के कारण हो सकता है।",
  "bundle_column_error.network.title": "नेटवर्क एरर",
  "bundle_column_error.retry": "दुबारा कोशिश करें",
  "bundle_column_error.return": "वापिस होम पर जाएँ",
  "bundle_column_error.routing.body": "अनुरोधित पेज पाया नहीं जा सका। क्या आप सुनिश्चित हैं कि एड्रेस बार में URL सही है?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "बंद",
  "bundle_modal_error.retry": "दुबारा कोशिश करें",
  "closed_registrations.other_server_instructions": "जब से मास्टोडन विकेंद्रीकरण हुआ है, आप दुसरे सर्वर पर एक अकाउंट बना सकते हैं और अब भी इसके साथ उपयोग कर सकते हैं",
  "closed_registrations_modal.description": "{domain} पर अकाउंट बनाना अभी संभव नहीं है, किन्तु कृपया ध्यान दें कि आपको मास्टोडन का प्रयोग करने के लिए {domain} पर एक अकाउंट का पूर्ण रूप से नहीं आवश्यकता हैं",
  "closed_registrations_modal.find_another_server": "दूसरा सर्वर ढूंढें",
  "closed_registrations_modal.preamble": "मास्टोडन विकेन्द्रित है, इसलिए कोई मतलब नहीं आप कहाँ अपना अकाउंट बना रहे हैं, आपको फॉलो करने के लिए सक्षम होना पड़ेगा और इस सर्वर पर किसी के साथ पूछना पड़ेगा I आप इसे खुद भी-चला सकते हैंI ",
  "closed_registrations_modal.title": "मास्टोडन पर जुड़ा जा रहा",
  "column.about": "अबाउट",
  "column.blocks": "ब्लॉक्ड यूज़र्स",
  "column.bookmarks": "पुस्तकचिह्न:",
  "column.community": "लोकल टाइम्लाइन",
  "column.direct": "निजी संदेश",
  "column.directory": "प्रोफाइल्स खोजें",
  "column.domain_blocks": "छुपे डोमेन्स",
  "column.favourites": "पसंदीदा",
  "column.firehose": "लाइव फीड",
  "column.follow_requests": "फॉलो रिक्वेस्ट्स",
  "column.home": "होम",
  "column.lists": "सूचियाँ",
  "column.mutes": "म्यूट किये हुए यूजर",
  "column.notifications": "नोटिफिकेशन्स",
  "column.pins": "पिनड टूट्स",
  "column.public": "फ़ेडरेटेड टाइम्लाइन",
  "column_back_button.label": "पीछे जाए",
  "column_header.hide_settings": "सेटिंग्स छुपाए",
  "column_header.moveLeft_settings": "कॉलम को बाएं ले जाये",
  "column_header.moveRight_settings": "कॉलम को दाएं ले जाये",
  "column_header.pin": "पिन",
  "column_header.show_settings": "सेटिंग्स दिखाएँ",
  "column_header.unpin": "अनपिन",
  "community.column_settings.local_only": "स्थानीय ही",
  "community.column_settings.media_only": "सिर्फ़ मीडिया",
  "community.column_settings.remote_only": "केवल सुदूर",
  "compose.language.change": "भाषा बदलें",
  "compose.language.search": "भाषाएँ खोजें...",
  "compose.published.body": "पोस्ट प्रकाशित हुआ।",
  "compose.published.open": "खोलें",
  "compose.saved.body": "पोस्ट सुरक्षित किया गया।",
  "compose_form.direct_message_warning_learn_more": "और जानें",
  "compose_form.encryption_warning": "मास्टोडॉन पर पोस्ट एन्ड-टू-एन्ड एन्क्रिप्टेड नहीं है। कोई भी व्यक्तिगत जानकारी मास्टोडॉन पर मत भेजें।",
  "compose_form.hashtag_warning": "ये पोस्ट किसी भी हैशटैग में लिस्ट नहीं किया जाएगा क्योंकि ये पब्लिक नहीं है। सिर्फ पब्लिक पोस्ट ही हैशटैग से खोजे जा सकते हैं।",
  "compose_form.lock_disclaimer": "आपका खाता {locked} नहीं है। आपको केवल फॉलोवर्स को दिखाई दिए जाने वाले पोस्ट देखने के लिए कोई भी फॉलो कर सकता है।",
  "compose_form.lock_disclaimer.lock": "लॉक्ड",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.poll.duration": "चुनाव की अवधि",
  "compose_form.poll.multiple": "बहुविकल्पी",
  "compose_form.poll.option_placeholder": "विकल्प {number}",
  "compose_form.poll.switch_to_multiple": "कई विकल्पों की अनुमति देने के लिए पोल बदलें",
  "compose_form.poll.switch_to_single": "एक ही विकल्प के लिए अनुमति देने के लिए पोल बदलें",
  "compose_form.poll.type": "स्टाइल",
  "compose_form.publish": "पोस्ट करें",
  "compose_form.reply": "जवाब दें",
  "compose_form.save_changes": "अपडेट करें",
  "compose_form.spoiler.marked": "चेतावनी के पीछे टेक्स्ट छिपा है",
  "compose_form.spoiler.unmarked": "टेक्स्ट छिपा नहीं है",
  "compose_form.spoiler_placeholder": "सामग्री चेतावनी (वैकल्पिक)",
  "confirmation_modal.cancel": "रद्द करें",
  "confirmations.block.confirm": "ब्लॉक",
  "confirmations.delete.confirm": "मिटाए",
  "confirmations.delete.message": "क्या आप वाकई इस स्टेटस को हटाना चाहते हैं?",
  "confirmations.delete_list.confirm": "मिटाए",
  "confirmations.delete_list.message": "क्या आप वाकई इस लिस्ट को हमेशा के लिये मिटाना चाहते हैं?",
  "confirmations.discard_edit_media.confirm": "डिस्कार्ड",
  "confirmations.discard_edit_media.message": "लिस्ट में जोड़ें",
  "confirmations.logout.confirm": "लॉग आउट करें",
  "confirmations.logout.message": "आप सुनिश्चित हैं कि लॉगआउट करना चाहते हैं?",
  "confirmations.mute.confirm": "शांत",
  "confirmations.redraft.confirm": "मिटायें और पुनःप्रारूपण करें",
  "confirmations.redraft.message": "क्या आप वाकई इस स्टेटस को हटाना चाहते हैं और इसे फिर से ड्राफ्ट करना चाहते हैं? पसंदीदा और बूस्ट खो जाएंगे, और मूल पोस्ट के उत्तर अनाथ हो जाएंगे।",
  "confirmations.unfollow.confirm": "अनफॉलो करें",
  "conversation.delete": "वार्तालाप हटाएँ",
  "conversation.mark_as_read": "पढ़ा गया के रूप में चिह्नित करें",
  "conversation.open": "वार्तालाप देखें",
  "conversation.with": "{names} के साथ",
  "copy_icon_button.copied": "क्लिपबोर्ड पर कॉपी किया गया",
  "copypaste.copied": "कॉपी किआ जा चूका है",
  "copypaste.copy_to_clipboard": "क्लिपबोर्ड पर कॉपी करें",
  "directory.federated": "ज्ञात फेडीवर्स से",
  "directory.local": "केवल {domain} से",
  "directory.new_arrivals": "नए आगंतुक",
  "directory.recently_active": "हाल में ही सक्रिय",
  "disabled_account_banner.account_settings": "अकाउंट सेटिंग्स",
  "disabled_account_banner.text": "आपका अकाउंट {disabledAccount} अभी डिसेबल्ड है",
  "dismissable_banner.community_timeline": "ये उन लोगों की सबसे रीसेंट पब्लिक पोस्ट हैं जिनके अकाउंट इनके {domain} द्वारा होस्ट किए गए हैं",
  "dismissable_banner.dismiss": "डिसमिस",
  "domain_block_modal.block": "सर्वर ब्लॉक करें",
  "domain_block_modal.block_account_instead": "इसकी जगह यह @{name} रखें",
  "domain_block_modal.they_can_interact_with_old_posts": "इस सर्वर की लोग आपकी पूरानी पोस्ट्स का अनुसरण किया जा sakta है।",
  "domain_block_modal.they_cant_follow": "इस सर्वर मेसे कोई भी आपका अनुसरण नहीं कर सकता।",
  "domain_block_modal.they_wont_know": "उनको पता नहीं चलेगा कि वे अवरोधित किए गए है।",
  "domain_block_modal.title": "डोमेन ब्लॉक करें",
  "domain_pill.server": "सर्वर",
  "domain_pill.username": "यूज़रनेम",
  "embed.instructions": "अपने वेबसाइट पर, निचे दिए कोड को कॉपी करके, इस स्टेटस को एम्बेड करें",
  "embed.preview": "यह ऐसा दिखेगा :",
  "emoji_button.activity": "गतिविधि",
  "emoji_button.clear": "मिटा दें",
  "emoji_button.custom": "निजीकृत",
  "emoji_button.flags": "झंडे",
  "emoji_button.food": "भोजन एवं पेय",
  "emoji_button.label": "इमोजी डाले",
  "emoji_button.nature": "प्रकृति",
  "emoji_button.not_found": "कोई इमोजी नहीं मिला! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "वस्तुएं",
  "emoji_button.people": "लोग",
  "emoji_button.recent": "अक्सर इस्तेमाल किया जाने वाला",
  "emoji_button.search": "खोजें",
  "emoji_button.search_results": "खोज परिणाम",
  "emoji_button.symbols": "प्रतीक",
  "emoji_button.travel": "यात्रा एवं स्थान",
  "empty_column.account_suspended": "खाता निलंबित",
  "empty_column.account_timeline": "सन्नाटा! यहां कोई टूट्स नहीं!",
  "empty_column.account_unavailable": "प्रोफाइल उपलब्ध नहीं",
  "empty_column.blocks": "आप अभी तक किसी भी यूजर के द्वारा ब्लॉक्ड नहीं हो।",
  "empty_column.bookmarked_statuses": "आपके पास अभी तक कोई बुकमार्क नहीं है। जब आप एक बुकमार्क करते हैं, तो यह यहां दिखाई देगा।",
  "empty_column.community": "लोकल टाइम्लाइन खाली है, कुछ देखने के लिये सार्वजनिक रूप से कुछ लिखें!",
  "empty_column.direct": "अभी तक आपको कोई निजी संदेश नहीं मिला है। जब भी आप निजी संदेश भेजेंगे या पाएंगे, तो वो यहां पर दिखेगा।",
  "empty_column.domain_blocks": "अभी तक कोई छुपा हुआ डोमेन नहीं है।",
  "empty_column.explore_statuses": "कुछ भी अभी ट्रैंडिंग नहीं है, कुछ देर बाद जांचे!",
  "empty_column.follow_requests": "अभी तक किसी ने भी आपका अनुसरण करने की विनती नहीं की है. जब भी कोई आपको विनती भेजेगा, वो यहाँ दिखेगी.",
  "empty_column.followed_tags": "आपने किसी हैशटैग को फॉलो नहीं किया है। जैसे ही आप फॉलो करेंगे, आपके फॉलो किए गए हैशटैग यहां दिखेंगे।",
  "empty_column.hashtag": "यह हैशटैग अभी तक खाली है।",
  "empty_column.home": "आपकी मुख्य कालक्रम अभी खली है. अन्य उपयोगकर्ताओं से मिलने के लिए और अपनी गतिविधियां शुरू करने के लिए या तो {public} पर जाएं या खोज का उपयोग करें।",
  "empty_column.list": "यह सूची अभी खाली है. जब इसके सदस्य कोई अभिव्यक्ति देंगे, तो वो यहां दिखाई देंगी.",
  "empty_column.mutes": "आपने अभी तक किसी भी उपयोगकर्ता को म्यूट नहीं किया है।",
  "empty_column.notifications": "आपके पास अभी तक कोई सूचना नहीं है। बातचीत शुरू करने के लिए दूसरों के साथ बातचीत करें।",
  "empty_column.public": "यहां कुछ नहीं है! सार्वजनिक रूप से कुछ लिखें, या इसे भरने के लिए अन्य सर्वर से उपयोगकर्ताओं का मैन्युअल रूप से अनुसरण करें",
  "error.unexpected_crash.explanation": "हमारे कोड या ब्राउज़र संगतता समस्या में बग के कारण, यह पृष्ठ सही ढंग से प्रदर्शित नहीं हो सका।",
  "error.unexpected_crash.explanation_addons": "यह पेज सही ढंग से प्रदर्शित नहीं किया जा सका। यह त्रुटि संभवतः ब्राउज़र ऐड-ऑन या स्वचालित अनुवाद टूल के कारण हुई है।",
  "error.unexpected_crash.next_steps": "पेज को रीफ्रेश करने का प्रयास करें। यदि वह मदद नहीं करता है, तो आप अभी भी मास्टोडन का उपयोग किसी भिन्न ब्राउज़र या नेटिव ऐप के माध्यम से कर सकते हैं।",
  "error.unexpected_crash.next_steps_addons": "उन्हें अक्षम करने और पृष्ठ को ताज़ा करने का प्रयास करें। यदि वह मदद नहीं करता है, तो आप अभी भी मास्टोडन का उपयोग किसी भिन्न ब्राउज़र या नेटिव ऐप के माध्यम से कर सकते हैं।",
  "errors.unexpected_crash.copy_stacktrace": "स्टैकट्रेस को क्लिपबोर्ड पर कॉपी करें",
  "errors.unexpected_crash.report_issue": "समस्या सूचित करें",
  "explore.suggested_follows": "लोग",
  "explore.trending_links": "समाचार",
  "explore.trending_statuses": "पोस्ट्स",
  "explore.trending_tags": "हैशटैग्स",
  "filter_modal.added.context_mismatch_explanation": "यह फ़िल्टर श्रेणी उस संदर्भ पर लागू नहीं होती जिसमें आपने इस पोस्ट को एक्सेस किया है। यदि आप चाहते हैं कि इस संदर्भ में भी पोस्ट को फ़िल्टर किया जाए, तो आपको फ़िल्टर को एडिट करना होगा।",
  "filter_modal.added.context_mismatch_title": "कंटेंट मिसमैच!",
  "filter_modal.added.expired_explanation": "यह फ़िल्टर श्रेणी समाप्त हो गई है, इसे लागू करने के लिए आपको समाप्ति तिथि बदलनी होगी।",
  "filter_modal.added.expired_title": "एक्सपीरेड फ़िल्टर!",
  "filter_modal.added.review_and_configure": "इस फ़िल्टर श्रेणी की समीक्षा करने और आगे कॉन्फ़िगर करने के लिए,{settings_link} पर जाएँ",
  "filter_modal.added.review_and_configure_title": "फ़िल्टर सेटिंग्स",
  "filter_modal.added.settings_link": "सेटिंग्स पेज",
  "filter_modal.added.short_explanation": "इस पोस्ट को निम्न फ़िल्टर श्रेणी में जोड़ा गया है:{title}",
  "filter_modal.added.title": "फ़िल्टर एडेड",
  "filter_modal.select_filter.context_mismatch": "इस संदर्भ में लागू नहीं होता",
  "filter_modal.select_filter.expired": "एक्सपीरेड",
  "filter_modal.select_filter.prompt_new": "नई श्रेणी:{name}",
  "filter_modal.select_filter.search": "खोजें या बनाएं",
  "filter_modal.select_filter.subtitle": "किसी मौजूदा श्रेणी का उपयोग करें या एक नया बनाएं",
  "filter_modal.select_filter.title": "इस पोस्ट को फ़िल्टर करें",
  "filter_modal.title.status": "किसी पोस्ट को फ़िल्टर करें",
  "firehose.all": "सभी",
  "firehose.local": "इस सर्वर पे",
  "firehose.remote": "बाकि के सर्वर",
  "follow_request.authorize": "अधिकार दें",
  "follow_request.reject": "अस्वीकार करें",
  "follow_requests.unlocked_explanation": "हालाँकि आपका खाता लॉक नहीं है, फिर भी {domain} डोमेन स्टाफ ने सोचा कि आप इन खातों के मैन्युअल अनुरोधों की समीक्षा करना चाहते हैं।",
  "follow_suggestions.dismiss": "दोबारा न दिखाएं",
  "followed_tags": "फॉलो किए गए हैशटैग्स",
  "footer.about": "अबाउट",
  "footer.directory": "प्रोफाइल्स डायरेक्टरी",
  "footer.get_app": "अप्प प्राप्त करें",
  "footer.keyboard_shortcuts": "कीबोर्ड शॉर्टकट",
  "footer.privacy_policy": "प्राइवेसी पालिसी",
  "footer.source_code": "सोर्स कोड देखें",
  "footer.status": "स्टेटस",
  "generic.saved": "सेव्ड",
  "getting_started.heading": "पहले कदम रखें",
  "hashtag.column_header.tag_mode.all": "और {additional}",
  "hashtag.column_header.tag_mode.any": "या {additional}",
  "hashtag.column_header.tag_mode.none": "बिना {additional}",
  "hashtag.column_settings.select.no_options_message": "कोई सुझाव नहीं मिला",
  "hashtag.column_settings.select.placeholder": "हैशटैग लिखें...",
  "hashtag.column_settings.tag_mode.all": "यह सभी",
  "hashtag.column_settings.tag_mode.any": "इनमें से कोई भी",
  "hashtag.column_settings.tag_mode.none": "इनमें से कोई भी नहीं",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.follow": "हैशटैग को फॉलो करें",
  "hashtag.unfollow": "हैशटैग को उनफ़ोल्लोव करें",
  "home.column_settings.show_reblogs": "बूस्ट दिखाए",
  "home.column_settings.show_replies": "जवाबों को दिखाए",
  "home.hide_announcements": "घोषणाएँ छिपाएँ",
  "home.show_announcements": "घोषणाएं दिखाएं",
  "interaction_modal.on_another_server": "एक अलग सर्वर पर",
  "interaction_modal.on_this_server": "इस सर्वर पे",
  "intervals.full.days": "{number, plural,one {# दिन} other {# दिन}}",
  "intervals.full.hours": "{number, plural,one {# घंटा} other {# घंटे}}",
  "keyboard_shortcuts.back": "वापस जाने के लिए",
  "keyboard_shortcuts.blocked": "अवरुद्ध उपयोगकर्ताओं की सूची खोलने के लिए",
  "keyboard_shortcuts.boost": "बढ़ावा देने के लिए",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "कंपोज़ टेक्स्ट-एरिया पर ध्यान केंद्रित करने के लिए",
  "keyboard_shortcuts.description": "विवरण",
  "keyboard_shortcuts.down": "सूची में शामिल करने के लिए",
  "keyboard_shortcuts.enter": "स्टेटस खोलने के लिए",
  "keyboard_shortcuts.federated": "फ़ैडरेटेड टाइम्लाइन खोलने के लिए",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "होम टाइम्लाइन खोलने के लिए",
  "keyboard_shortcuts.hotkey": "हॉट-की",
  "keyboard_shortcuts.legend": "इस लीजेंड को दिखाने के लिए",
  "keyboard_shortcuts.local": "लोकल टाइम्लाइन खोलने के लिए",
  "keyboard_shortcuts.mention": "लेखक को मेन्शन करने के लिए",
  "keyboard_shortcuts.muted": "म्यूटेड यूजर की लिस्ट खोलने के लिए",
  "keyboard_shortcuts.my_profile": "आपकी प्रोफाइल खोलने के लिए",
  "keyboard_shortcuts.notifications": "नोटिफिकेशन कॉलम खोलने के लिए",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "पिनड टूट्स की लिस्ट खोलने के लिए",
  "keyboard_shortcuts.profile": "लेखक की प्रोफाइल खोलने के लिए",
  "keyboard_shortcuts.reply": "जवाब के लिए",
  "keyboard_shortcuts.requests": "फॉलो रिक्वेस्ट लिस्ट खोलने के लिए",
  "keyboard_shortcuts.search": "गहरी खोज के लिए",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "बंद करें",
  "lightbox.next": "अगला",
  "lightbox.previous": "पिछला",
  "limited_account_hint.action": "फिर भी प्रोफाइल दिखाओ",
  "limited_account_hint.title": "यह प्रोफ़ाइल {domain} के मॉडरेटर द्वारा छिपाई गई है.",
  "lists.delete": "सूची हटाएँ",
  "lists.edit": "सूची संपादित करें",
  "lists.replies_policy.followed": "अन्य फोल्लोवेद यूजर",
  "lists.replies_policy.list": "सूची के सदस्य",
  "lists.replies_policy.none": "कोई नहीं",
  "media_gallery.hide": "छिपाएं",
  "navigation_bar.about": "विवरण",
  "navigation_bar.blocks": "ब्लॉक्ड यूज़र्स",
  "navigation_bar.bookmarks": "पुस्तकचिह्न:",
  "navigation_bar.direct": "निजी संदेश",
  "navigation_bar.domain_blocks": "Hidden domains",
  "navigation_bar.favourites": "पसंदीदा",
  "navigation_bar.filters": "वारित शब्द",
  "navigation_bar.follow_requests": "अनुसरण करने के अनुरोध",
  "navigation_bar.followed_tags": "हैशटैग को फॉलो करें",
  "navigation_bar.lists": "सूचियाँ",
  "navigation_bar.logout": "बाहर जाए",
  "navigation_bar.mutes": "शांत किए गए सभ्य",
  "navigation_bar.preferences": "पसंदे",
  "navigation_bar.search": "ढूंढें",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notification.status": "{name} ने अभी पोस्ट किया",
  "notifications.clear": "सूचनाएं हटाए",
  "notifications.column_settings.admin.report": "नई रिपोर्ट:",
  "notifications.column_settings.favourite": "पसंदीदा:",
  "notifications.column_settings.follow": "नए फ़ॉलोअर्स",
  "notifications.column_settings.mention": "उल्लेख:",
  "notifications.column_settings.poll": "चुनाव परिणाम",
  "notifications.column_settings.push": "पुश सूचनाएँ",
  "notifications.column_settings.reblog": "बूस्ट:",
  "notifications.column_settings.show": "कॉलम में दिखाएँ",
  "notifications.column_settings.sound": "ध्वनि चलाएँ",
  "notifications.column_settings.status": "New toots:",
  "notifications.column_settings.unread_notifications.category": "अपठित सूचनाएं",
  "notifications.column_settings.unread_notifications.highlight": "अपठित सूचनाओं को हाइलाइट करें",
  "notifications.column_settings.update": "संपादन:",
  "notifications.filter.all": "सभी",
  "notifications.filter.boosts": "बूस्ट",
  "notifications.filter.favourites": "पसंदीदा",
  "notifications.filter.follows": "फॉलो",
  "notifications.filter.mentions": "उल्लेख",
  "notifications.filter.polls": "चुनाव परिणाम",
  "notifications.grant_permission": "अनुमति दें",
  "notifications.group": "{count} सूचनाएँ",
  "onboarding.profile.discoverable": "अपना प्रोफाइल खोजने योग्य बनाएं",
  "onboarding.profile.discoverable_hint": "जब आप मॅस्टोडॉन पर डिस्कवरेबिलिटी चुनते हैं तो आपके पोस्ट ट्रेंडिंग और सर्च में दिख सकते हैं और आपका प्रोफाइल आपके ही जैसे अकाउंट्स को सुझाया जा सकता है।",
  "onboarding.profile.display_name": "प्रदर्शित नाम",
  "poll.closed": "बंद कर दिया",
  "poll.refresh": "रीफ्रेश करें",
  "poll.vote": "वोट",
  "poll.voted": "आपने इसी उत्तर का चुनाव किया है।",
  "privacy.change": "Adjust status privacy",
  "privacy.public.short": "सार्वजनिक",
  "recommended": "अनुशंसित",
  "refresh": "रीफ्रेश करें",
  "relative_time.days": "{number}दिन",
  "relative_time.full.days": "{number, plural, one {# दिन} other {# दिन}} पहले",
  "relative_time.full.hours": "{number, plural,one {# घंटा} other {# घंटे}} पहले",
  "relative_time.full.just_now": "अभी-अभी",
  "relative_time.full.minutes": "{number, plural, one {# मिनट} other {# मिनट}} पहले",
  "relative_time.full.seconds": "{number, plural, one {# सेकंड} other {# सेकंड}} पहले",
  "relative_time.hours": "{number} घंटे",
  "relative_time.just_now": "अभी",
  "relative_time.minutes": "{number} मिनट",
  "relative_time.seconds": "{number} सेकंड",
  "relative_time.today": "आज",
  "reply_indicator.cancel": "रद्द करें",
  "report.block": "ब्लॉक",
  "report.block_explanation": "आपको उनकी पोस्टें नहीं दिखेंगे। वे आपकी पोस्टें को देख नहीं पाएंगे और आपको फ़ॉलो नहीं कर पाएंगे। उन्हे पता लगेगा कि वे blocked हैं।",
  "report.categories.other": "अन्य",
  "report.categories.spam": "अवांछित",
  "report.category.title_account": "रूपरेखा",
  "report.close": "स्वीकार करें",
  "report.comment.title": "क्या और कुछ है जिसके बारे में आपको लगता है कि हमें सूचित होना चाहिए?",
  "report.next": "आगे",
  "report.placeholder": "Type or paste additional comments",
  "report.reasons.dislike": "मुझे यह पसंद नहीं है",
  "report.reasons.legal": "यह अवैध है",
  "report.reasons.legal_description": "आप मानते हैं कि यह आपके या सर्वर के देश के कानून का उल्लंघन करता है",
  "report.reasons.other": "कुछ और है।",
  "report.reasons.violation": "यह सर्वर नियमों का उल्लंघन करता है",
  "report.rules.title": "किन नियमों का उल्लंघन हो रहा है?",
  "report.statuses.subtitle": "लागू होने वाले सभी का चयन करें",
  "report.statuses.title": "क्या ऐसे कोई पोस्ट हैं जो इस रिपोर्ट का समर्थन करते हों?",
  "report.submit": "सबमिट करें",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.no_recent_searches": "कोई हालिया खोज नहीं",
  "search.placeholder": "खोजें",
  "search.quick_action.account_search": "प्रोफ़ाइल मिले {x}",
  "search.quick_action.go_to_account": "प्रोफ़ाइल पर जाएँ {x}",
  "search.quick_action.go_to_hashtag": "हैशटैग पर जाएं {x}",
  "search.quick_action.open_url": "URL मॅस्टोडॉन में खोलें",
  "search.quick_action.status_search": "पोस्ट मिलें {x}",
  "search_popout.full_text_search_disabled_message": "{domain} पर उपलब्ध नहिं है।",
  "search_popout.quick_actions": "त्वरित क्रियाएं",
  "search_popout.recent": "हालिया खोजें",
  "search_results.accounts": "प्रोफ़ाइल",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "@{name} को ब्लॉक करें",
  "status.bookmark": "बुकमार्क",
  "status.cannot_reblog": "रिपोस्ट को बूस्ट नहीं किया जा सकता",
  "status.copy": "Copy link to status",
  "status.delete": "हटाएं",
  "status.detailed_status": "विस्तृत वार्ता दृश्य",
  "status.direct": "निजी संदेश @{name} से",
  "status.edited": "पिछला संशोधन {date}",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.media.open": "खोलने के लिए क्लिक करें",
  "status.media.show": "दिखाने के लिए क्लिक करें",
  "status.mention": "@{name} का उल्लेख करें",
  "status.more": "अतिरिक्त",
  "status.mute": "@{name} म्यूट करें",
  "status.mute_conversation": "इस वार्तालाप को म्यूट करें",
  "status.open": "Expand this status",
  "status.pin": "प्रोफ़ाइल पर पिन करें",
  "status.read_more": "और पढ़ें",
  "status.reblog": "बूस्ट",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.replied_to": "{name} का उत्तर दें",
  "status.reply": "जवाब",
  "status.sensitive_warning": "संवेदनशील विषय वस्तु",
  "status.share": "शेयर करें",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translated_from_with": "{provider} का उपयोग करते हुये {lang} से अनुवादित किया गया",
  "tabs_bar.home": "होम",
  "tabs_bar.notifications": "सूचनाएँ",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_form.edit": "संशोधन करें",
  "upload_progress.label": "अपलोडिंग...",
  "video.download": "फाइल डाउनलोड करें"
}
